/* Money helpers for Shopify Markets (config: snippets/jx-money-config.liquid). Took over from the Bucks app, which only
   rewrote prices on screen. Shopify Markets now prices products in the shopper's currency; this file covers the rest:
   - window.jxMoney(cents, whole): formats an amount like Shopify does in the shopper's currency (learned from a sample),
     for scripts that build prices themselves (cart drawer total, collection bundle modal).
   - Typed US-dollar amounts (gift "worth" values, per-serving costs) are tagged by the theme: [data-jx-usd="3000"] holds
     the USD cents, [data-jx-usd-text] wraps typed copy whose "$12.34" amounts are USD. For shoppers in another currency
     they are converted with Shopify's exchange rate (Shopify.currency.rate); whole-dollar amounts stay whole.
   Only tagged amounts are touched: Australian, Canadian and NZ prices also start with "$". */
(function () {
  'use strict';
  var cfg = window.jxMoneyCfg || {};

  function parseSample(sample) {
    var s = String(sample || '$1,234.56');
    var m = /1([^\d]?)23\d(?:([^\d])(\d+))?/.exec(s); /* 1234.56, or 1235 in currencies without decimals */
    if (!m) return { prefix: '$', suffix: '', thou: ',', dec: '.', decimals: 2 };
    return {
      prefix: s.slice(0, m.index),
      suffix: s.slice(m.index + m[0].length),
      thou: m[1] || '',
      dec: m[2] || '',
      decimals: m[3] ? m[3].length : 0
    };
  }
  var fmt = parseSample(cfg.sample);

  function jxMoney(cents, whole) {
    var neg = cents < 0;
    var value = Math.abs(cents) / 100;
    var decimals = whole ? 0 : fmt.decimals;
    var parts = value.toFixed(decimals).split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, fmt.thou);
    var body = decimals > 0 ? int + fmt.dec + parts[1] : int;
    return (neg ? '-' : '') + fmt.prefix + body + fmt.suffix;
  }
  window.jxMoney = jxMoney;
  window.jxMoneyCurrency = cfg.currency || '';

  if (!cfg.currency || !cfg.base || cfg.currency === cfg.base) return;
  document.documentElement.classList.add('jx-foreign'); /* CSS: let long local prices wrap */
  var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
  if (!rate || !isFinite(rate)) return;

  /* USD cents -> shopper's currency text. Whole dollars ($30) stay whole (€28), cents ($1.29) keep cents. */
  function convert(usdCents) {
    var whole = usdCents % 100 === 0;
    var local = usdCents * rate;
    return whole ? jxMoney(Math.round(local / 100) * 100, true) : jxMoney(Math.round(local), false);
  }

  var USD = /(?:US)?\$\s?(\d{1,3}(?:,\d{3})+|\d+)(?:\.(\d{1,2}))?(?!\d)/g;
  function convertText(node) {
    var text = node.nodeValue;
    if (text.indexOf('$') === -1) return;
    var out = text.replace(USD, function (m, int, dec) {
      var cents = parseInt(int.replace(/,/g, ''), 10) * 100 + (dec ? parseInt((dec + '0').slice(0, 2), 10) : 0);
      return convert(cents);
    });
    if (out !== text) node.nodeValue = out;
  }

  function run(root) {
    (root || document).querySelectorAll('[data-jx-usd]:not([data-jx-usd-done])').forEach(function (el) {
      var cents = parseInt(el.getAttribute('data-jx-usd'), 10);
      if (!isFinite(cents)) return;
      el.textContent = convert(cents);
      el.setAttribute('data-jx-usd-done', '');
    });
    (root || document).querySelectorAll('[data-jx-usd-text]:not([data-jx-usd-done])').forEach(function (el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(convertText);
      el.setAttribute('data-jx-usd-done', '');
    });
  }
  window.jxConvertUsd = run;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
